<!--
 * @Author: zxf
 * @Date: 2022-08-08 16:50:37
 * @LastEditors: zxf
 * @LastEditTime: 2023-07-04 16:31:00
 * @Description: 检测项管理
-->
<template>
  <div
    v-loading="loading"
    class="l-page l-page--search"
  >
    <!-- 页面头部 Start -->
    <div
      class="l-page__header c-page__header"
    >
      <!-- 页面标题 -->
      <div
        class="c-page__header-title"
      >
        <h2
          v-menu-title
          style="display: inline-block;"
        >
          项目检查项查看
        </h2>
        <span style="display: inline-block; padding-left: 12px; color: #2296f7;">（已检测：{{ yjcxs }} 、 未检测：{{ wjcxs }}）</span>
      </div>

      <!-- 标题栏按钮区域 Start -->
      <div
        class="c-page__header-btns"
      >
        <k-button
          btn-text="查询"
          :auth-type="false"
          type="primary"
          icon="kestrel-icon ki-search"
          @click="refreshSearch()"
        />
        <k-button
          btn-text="重置"
          :auth-type="false"
          icon="kestrel-icon ki-repeat"
          @click="resetForm()"
        />
      </div>
    <!-- 标题栏按钮区域 End -->
    </div>
    <!-- 页面头部 End -->

    <!-- 查询条件 Start -->
    <div
      class="l-page__item l-page--search__item"
    >
      <hm-page-card
        title="查询条件"
        class="c-card--condition"
      >
        <!-- 查询条件表单 Start -->
        <!-- tips：c-condition__form类用于查询类布局的查询条件模块使用 -->
        <el-form
          ref="filterParams"
          class="c-form c-condition__form"
          :model="filterParams"
          :inline="true"
          label-position="right"
          label-width="120px"
          label-suffix="："
        >
          <el-row
            class="c-form__row"
          >
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="检查内容"
                prop="jcnrsz"
              >
                <select-sb
                  v-model="filterParams.jcnrsz"
                  type="jc"
                  clearable
                  show-all
                />
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="6"
            >
              <el-form-item
                class="c-form__item"
                label="检测结果"
                prop="jcjg"
              >
                <el-select
                  v-model="filterParams.jcjg"
                  clearable
                  class="c-form__select"
                  style="width: 100%;"
                  placeholder="请选择检测结果"
                >
                  <el-option
                    value="Y"
                    label="合格"
                  />
                  <el-option
                    value="N"
                    label="不合格"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="6"
            >
              <el-form-item
                class="c-form__item"
                label="检测点与明细数"
                prop="jcdmxs"
              >
                <el-select
                  v-model="filterParams.jcdmxs"
                  clearable
                  class="c-form__select"
                  style="width: 100%;"
                  placeholder="请选择"
                >
                  <el-option
                    value="Y"
                    label="相同"
                  />
                  <el-option
                    value="N"
                    label="不同"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      <!-- 查询条件表单 End -->
      </hm-page-card>
    </div>
    <!-- 查询条件 End -->

    <!-- 页面主内容：查询列表 Start -->
    <div
      class="l-page__body l-page--search__body"
    >
      <!-- tips：l-page__tabs--single类用于只有一个tab时修饰页面使用 -->
      <el-tabs
        type="border-card"
        class="l-page__tabs l-page__tabs--single"
      >
        <el-tab-pane
          label="查询结果"
        >
          <!-- table的ref的命名根据业务名称修改 -->
          <k-table-infinite
            v-loading="loading"
            :infinite-scroll-disabled="isDisabled"
            :infinite-scroll-immediate="false"
            height="100%"
            :table-column="tableColumn"
            :data="page.rows"
            @infiniteLoad="getDataNextPage"
          >
            <template
              #jcjg="scope"
            >
              <span
                :class="{
                  'u-text-success' : (scope.row.jcjg==='合格') ,
                  'u-text-danger' : (scope.row.jcjg!=='合格')
                }"
              >
                {{ (scope.row.jcjg === '合格') ? '合格' : '不合格' }}
              </span>
            </template>
            <!-- <template
              #jcds="scope"
            >
              <el-input-number
                v-model="scope.row.jcds"
                class="c-form__input-number"
                :min="scope.row.instance > 0 ? scope.row.instance : 0"
                label="请输入检测点数"
              />
            </template>
            <template
              #bz="scope"
            >
              <el-input
                v-model="scope.row.bz"
                class="c-form__input"
                type="text"
                placeholder="请输入备注"
              />
            </template> -->
          </k-table-infinite>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- 页面主内容：查询列表 End -->
  </div>
</template>
<script>
import { jcxService } from './jcx.service';
import elTableInfiniteScroll from 'el-table-infinite-scroll';
import KTableInfinite from '../../../components/KTable/KTableInfinite.vue';
export default {
  name: 'JcxIndex',
  components: { KTableInfinite },
  directives: {
    'el-table-infinite-scroll': elTableInfiniteScroll
  },
  data () {
    return {
      loading: false, // 页面是否loading状态
      isLoadFlag: false, // 加载标志
      isMore: false, // 更多标志
      isDisabled: false, // 可不用标志
      loadedPageNo: 0, // 已加载页码

      /* 查询条件（页面绑定的查询条件） start */
      filterParams: {
        jcnrsz: null, // 检测内容数组
        jcnr: null, // 检查内容
        jcx: null, // 检测项
        jcjg: null, // 检测结果
        jcdmxs: null // 检测点与明细数
      },
      /* 查询条件 end */

      /* 分页实际查询条件（避免查询条件的双向绑定导致点击分页按钮，获取到的数据不符合真实过滤条件） Start */
      trueFilterParams: {},
      /* 分页实际查询条件 End */

      /* 导出实际查询条件（避免查询条件的双向绑定导致点击导出按钮，获取到的数据与查询结果不一致） Start */
      exportFilterParams: {},
      /* 导出实际查询条件 End */

      /* 查询结果 Start */
      page: {
        rows: [],
        total: 0,
        pageSize: 100,
        pageNo: 0,
        totalPages: 0
      },
      /* 查询结果 End */

      /* 表格列配置Start */
      tableColumn: [
        { key: 'index', label: '序号', align: 'center', width: this.$commonConfig.tableWidthConfig.common_xh, type: 'index' },
        { key: 'bh', label: '编号', align: 'left', width: '80', type: 'text' },
        { key: 'jcx', label: '检测项', align: 'left', minWidth: '150', type: 'text' },
        { key: 'jcbz', label: '检测标准（规范要求）', align: 'left', minWidth: '180', type: 'text' },
        { key: 'zydj', label: '重要等级', align: 'center', width: '80', type: 'text' },
        { key: 'jcds', label: '检测点数', align: 'center', width: '140', type: 'text' },
        { key: 'bhgds', label: '不合格点数', align: 'center', width: '80', type: 'text' },
        { key: 'mxsl', label: '明细数量', align: 'center', width: '80', type: 'text' },
        { key: 'jcjg', slotName: 'jcjg', label: '检测结果', align: 'center', width: '80', type: 'text' },
        { key: 'bz', label: '备注', align: 'left', minWidth: '120', type: 'text' }
      ],
      /* 表格列配置End */
      yjcxs: 0, // 已检测项
      wjcxs: 0, // 未检测项
      xmId: null // 检测项目ID
    };
  },
  methods: {
    getDataNextPage () {
      if (this.loadedPageNo === this.page.pageNo + 1) {
      } else if (this.loadedPageNo !== this.page.pageNo + 1 && this.page.pageNo < this.page.totalPages) {
        this.isMore = true;
        this.isDisabled = false;
        this.search(this.loadedPageNo + 1);
      } else {
        this.isMore = false;
        this.isDisabled = true;
      }
    },
    /**
     * @description: 核对数据项
     * @return {*}
     */
    handleHdjc () {
      this.loading = true;
      this.page.rows.forEach(r => {
        r.jcds = r.mxsl;
      });
      this.loading = false;
    },

    /**
     * @description: 获取检测项统计信息
     * @return {*}
     */
    getJcxCountInfo () {
      jcxService.getJcxCountInfo(this.xmId)
        .then(rsp => {
          console.log(rsp);
          this.wjcxs = rsp.data.data.wjcxs;
          this.yjcxs = rsp.data.data.yjcxs;
        })
        .catch(err => {
          console.error('获取检测项统计信息出错！', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 保存
     * @return {*}
     */
    handleSave () {
      this.loading = true;
      jcxService.saveJcx(this.xmId, this.page.rows)
        .then(rsp => {
          this.$alert('保存成功！', '提示', {
            confirmButtonText: '确定',
            type: 'success',
            callback: action => {
            }
          });
        })
        .catch(err => {
          console.error('检测项保存出错！', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 记录分页查询条件，调用查询方法
     * @return {*}
     */
    refreshSearch () {
      this.page.rows = [];
      this.page.pageNo = 0;
      this.page.totalPages = 0;
      this.trueFilterParams = JSON.parse(JSON.stringify(this.filterParams));
      if (this.filterParams.jcnrsz && this.filterParams.jcnrsz.includes('/')) {
        [this.trueFilterParams.jcnr, this.trueFilterParams.jcx] = this.filterParams.jcnrsz.split('/');
      }

      this.search(1);
      this.getJcxCountInfo();
    },
    /**
     * @description: 查询列表方法
     * @param {number} _pageNo
     * @return {*}
     */
    search (_pageNo = 1) {
      const _this = this;
      /* 处理分页参数 Start */
      _this.trueFilterParams.pageSize = this.page.pageSize;
      _this.trueFilterParams.pageNo = _pageNo;
      /* 处理分页参数 End */

      _this.loading = true;
      _this.loadedPageNo = _pageNo;
      console.log(_this.trueFilterParams);
      jcxService.queryJcx(_this.trueFilterParams)
        .then(rsp => {
          _this.page.pageNo = rsp.data.pageNo;
          _this.page.totalPages = rsp.data.totalPages;
          _this.page.rows = _this.page.rows.concat(rsp.data.rows);

          if (_this.page.pageNo < _this.page.totalPages) {
            _this.isDisabled = false;
            _this.isMore = true;
          }
        })
        .catch(err => {
          console.error('查询错误！', err);
        })
        .finally(() => {
          _this.loading = false;
        });
    },
    /**
     * @description: 重置页面为初始状态
     * @param：
     * @return {*}
     */
    resetForm () {
      this.$refs.filterParams.resetFields();
    },
    /**
     * @description: 删除
     * @return {*}
     */
    handleDel (_row) {
      const _this = this;
      _this.$confirm(`是否确认删除此任务：${_row.infoName}？`, '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.loading = true;
        jcxService.delete(_row.id)
          .then(rsp => {
            _this.$alert('删除成功！', '提示', {
              confirmButtonText: '确定',
              type: 'success',
              callback: action => {
              }
            });
            _this.refreshSearch();
          })
          .catch(err => {
            console.error('删除失败！', err);
          })
          .finally(() => {
            _this.loading = false;
          });
      }).catch(() => {
      });
    },
    /**
     * @description: 导出业务流程
     * @param {*}
     * @return {*}
     */
    handleExport () {
      this.loading = true;
      jcxService.export(this.exportFilterParams)
        .then(rsp => {
          const fileStream = rsp.data;
          const fileName = decodeURIComponent(escape(rsp.headers['content-disposition'].split('=')[1]));
          this.$HMUtil.downloadStreamFile(fileStream, fileName);
        })
        .catch(err => {
          console.error('导出错误！', err);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  created () {
    this.xmId = this.$route.params.xmId;
    this.filterParams.xmId = this.$route.params.xmId;
    this.refreshSearch();
  },
  activated () {
    this.xmId = this.$route.params.xmId;
    // if (this.$route.params.isRefresh) {
    //   this.refreshSearch();
    // }
  }
};
</script>
